// src/rect.ts
var point = (x, y) => ({ x, y });
function createRect(r) {
  const { x, y, width, height } = r;
  const midX = x + width / 2;
  const midY = y + height / 2;
  return {
    x,
    y,
    width,
    height,
    minX: x,
    minY: y,
    maxX: x + width,
    maxY: y + height,
    midX,
    midY,
    center: point(midX, midY)
  };
}
var hasProp = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
function isRect(v) {
  return hasProp(v, "x") && hasProp(v, "y") && hasProp(v, "width") && hasProp(v, "height");
}
function getRectCenters(v) {
  const top = point(v.midX, v.minY);
  const right = point(v.maxX, v.midY);
  const bottom = point(v.midX, v.maxY);
  const left = point(v.minX, v.midY);
  return { top, right, bottom, left };
}
function getRectCorners(v) {
  const top = point(v.minX, v.minY);
  const right = point(v.maxX, v.minY);
  const bottom = point(v.maxX, v.maxY);
  const left = point(v.minX, v.maxY);
  return { top, right, bottom, left };
}
function getRectEdges(v) {
  const c = getRectCorners(v);
  const top = [c.top, c.right];
  const right = [c.right, c.bottom];
  const bottom = [c.left, c.bottom];
  const left = [c.top, c.left];
  return { top, right, bottom, left };
}

export {
  createRect,
  isRect,
  getRectCenters,
  getRectCorners,
  getRectEdges
};
